import { BaseMutations } from '@/store/base-mutations';
import { ClientContacts } from '@/modules/client-contacts/types';
import { DataPilot } from '@/modules/data-pilot/types';
import { DataPilotState } from './state';
import { default_clients_filters } from '../services';

export default class DataPilotMutations extends BaseMutations<DataPilotState> {
  SET_CLIENT(data: DataPilot.Client) {
    this.state.client = { ...data };
  }

  CLEAR_FILTERS() {
    this.state.filters = { ...default_clients_filters() };
  }

  SET_TAGS(tags: DataPilot.Tag[]) {
    this.state.tags = tags;
  }

  SET_MODELS(models: DataPilot.Model[]) {
    this.state.models = models;
  }

  SET_EVENTS(events: DataPilot.Event[]) {
    this.state.events = events;
  }

  SET_RESPONSIBLE_CLIENTS(responsible_clients: DataPilot.ResponsibleClient[]) {
    this.state.responsible_clients = responsible_clients;
  }

  SET_EVENT_STATUSES(event_statuses: DataPilot.EventStatus[]) {
    this.state.event_statuses = event_statuses;
  }

  SET_RESPONSIBLE_EVENTS(responsible_events: DataPilot.ResponsibleEvent[]) {
    this.state.responsible_events = responsible_events;
  }

  SET_PRIORITIES(priorities: DataPilot.Priority[]) {
    this.state.priorities = priorities;
  }

  SET_CLIENT_STATUSES(client_statuses: DataPilot.ClientStatus[]) {
    this.state.client_statuses = client_statuses;
  }

  SET_PRODUCT_CATEGORIES(product_categories: DataPilot.ProductCategory[]) {
    this.state.product_categories = product_categories;
  }

  SET_MARKS(marks: DataPilot.Mark[]) {
    this.state.marks = marks;
  }

  SET_OKVEDS(okveds: DataPilot.Okved[]) {
    this.state.okveds = okveds;
  }

  SET_REGIONS(regions: string[]) {
    this.state.regions = regions;
  }

  SET_CITIES(cities: string[]) {
    this.state.cities = cities;
  }

  SET_CLIENT_CATEGORIES(client_categories: DataPilot.ClientCategory[]) {
    this.state.client_categories = client_categories;
  }

  SET_TAX_SYSTEM(tax_systems: DataPilot.TaxSystem[]) {
    this.state.tax_systems = tax_systems;
  }

  SET_DEVICES(devices: DataPilot.Device[]) {
    this.state.devices = devices;
  }

  SET_COUNT_CLIENTS(count_clients: number) {
    this.state.count_clients = count_clients;
  }

  SET_METRICS(metrics: any) {
    this.state.metrics = { ...metrics };
  }

  SET_RESPONSIBLE_CLIENT(data: any) {
    this.state.client.user = { ...data };
  }

  TOGGLE_LOADING(toggle: boolean) {
    this.state.loading = toggle;
  }

  SET_CLIENT_EVENTS(client_events: any) {
    this.state.client_events = client_events;
  }

  SET_ROUTE_TAB(tab: number) {
    this.state.tab = tab;
  }

  SET_CURRENT_CLIENT_CONTACTS(data: ClientContacts.ClientContact[]) {
    this.state.client.client_contacts = data;
  }

  SET_MARK(data: DataPilot.Mark) {
    this.state.marks.push(data);
  }

  SET_CLIENT_MARK(data: DataPilot.Mark) {
    this.state.client.client_marks.push(data);
  }

  DELETE_MARK(id: number) {
    const index = this.state.client.client_marks.findIndex(
      (mark) => mark.id === id,
    );

    if (index !== -1) {
      this.state.client.client_marks.splice(index, 1);
    }
  }

  DELETE_MARK_IN_FILTER(id: number) {
    let index = this.state.filters.mark_ids.findIndex(
      (item) => item === id,
    );

    if (index !== -1) {
      this.state.filters.mark_ids.splice(index, 1);
    }

    index = this.state.marks.findIndex(
      (mark) => mark.id === id,
    );

    if (index !== -1) {
      this.state.marks.splice(index, 1);
    }
  }

  SET_MARK_FILTER(id: number) {
    this.state.filters.mark_ids = [id];
  }
}
